import React from 'react'

import GlobalSearchContainerPane, { GlobalSearchContainerPaneContent } from './GlobalSearchContainerPane'

import GlobalSearchTabContents from './GlobalSearchTabContents'
import GlobalSearchTabs from './GlobalSearchTabs'
import config from 'constants/config'

interface Props {
  tabs: Map<App.SearchVertical, App.GlobalSearchVerticalTab>
  selectedTab: App.SearchVertical
  onTabSelect: (tab: App.SearchVertical) => void
}

function GlobalSearchTabsPane(props: Props) {
  const { tabs, selectedTab = 'hotels', onTabSelect } = props

  return <GlobalSearchContainerPane shadow="bottom-small" displayMobile={!config.USE_INSPIRATIONAL_SEARCH}>
    {tabs.size >= 2 && (
      <GlobalSearchTabs
        selectedTabKey={selectedTab}
        tabs={tabs}
        onTabSelect={onTabSelect}
      />
    )}
    <GlobalSearchContainerPaneContent>
      <GlobalSearchTabContents tabs={tabs} selectedTabKey={selectedTab} />
    </GlobalSearchContainerPaneContent>
  </GlobalSearchContainerPane>
}

export default GlobalSearchTabsPane
